<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">Experts's Clients</h1>
    </div>
    <div>
      <img class="separator" src="../../../../assets/icons/separator.svg" />
    </div>
    <div>
      <h1 class="sub-headeradminui-text">{{ totalCount }}</h1>
    </div>
  </div>

</div>
<div class="flex items-start gap-4" style="background: #ececec; padding: 30px">
  <nz-card
    [nzLoading]="expertClientSpinner"
    *ngIf="expertDetail"
    style="width: 100%"
    [nzBordered]="false"
    nzTitle="Expert info"
  >
    <!-- Flex container for the two columns -->
    <div class="flex-container">

      <!-- Column 1: Expert Details -->
      <div class="column">
        <p>
          <strong>Expert Name :</strong>
          {{ expertDetail.firstName }} {{ expertDetail.lastName }}
        </p>
        <p><strong>Expert Email :</strong> {{ expertDetail.email }}</p>
        <br />
        <div class="flex gap-1 flex-wrap">
          <strong>userInterest:</strong>
          <nz-tag
            *ngFor="let tag of expertDetail.userInterest"
            [nzColor]="'purple'"
          >
            {{ tag.value }}
          </nz-tag>
        </div>
      </div>

      <!-- Column 2: About Section -->
      <div class="column">
        <p><strong>About:</strong></p>
        <p>{{ expertDetail.aboutTherapist }}</p>
      </div>

    </div>
  </nz-card>
</div>
<nz-spin [nzSpinning]="expertClientSpinner">
  <div nz-row class="mt-2" nzJustify="end" nzAlign="middle">
    <div nz-col class="p-1">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for name,email"
        />
      </nz-input-group>
    </div>
    <div nz-row>
      <nz-tabset (nzSelectChange)="tabChange($event)">
        <nz-tab nzTitle="Active Clients">
          <app-table
            #activeTableComponent
            [inputTableData]="tableData"
            [gridRequest]="gridRequest"
            (resetFilterEvent)="resetFilter()"
            (expertClientSortEvent)="expertClientSort($event)"
            (partnerFilterEvent)="partnerFilter($event)"
            (pageChangeEvent)="nzPageIndexChange($event)"
            (pageSizeChangeEvent)="nzPageSizeChange($event)"
            (testUserEvents)="testFilter($event)"
          ></app-table>
        </nz-tab>
        <nz-tab nzTitle="Inactive Clients">
          <app-table
            #inactiveTableComponent
            [inputTableData]="tableData"
            [gridRequest]="gridRequest"
            (resetFilterEvent)="resetFilter()"
            (expertClientSortEvent)="expertClientSort($event)"
            (partnerFilterEvent)="partnerFilter($event)"
            (pageChangeEvent)="nzPageIndexChange($event)"
            (pageSizeChangeEvent)="nzPageSizeChange($event)"
            (testUserEvents)="testFilter($event)"
          ></app-table>
        </nz-tab>
      </nz-tabset>
    </div>
    <ng-template #suffixButton>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        nzSearch
        (click)="searchGlobal()"
      >
        Search
      </button>
    </ng-template>
  </div>
</nz-spin>
